import { createElement } from "@max/max";
import { getFullScreenSize } from "@/utils/layout";
import ModalBaseContainer from '@max/leez-modal-base-container';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import TopView from '@max/leez-top-view';
import Avatar from '@/components/avatar';
import './index.scss';
import LImage from "@max/leez-image";
import Image from '@hfe/max-image';
import { RewardType } from "@/types/teamRanking";
import RecyclerView from '@hfe/max-recyclerview';
import ModalBottomBtn from "../modal-bottom-button";
export default function PublicityPopup(props) {
    const { fullScreenHeight } = getFullScreenSize();
    const { teamInfo, winnerTeams = [], loadMore } = props;
    const { teamName, teamValue, teamRank, obtainReward } = teamInfo || {};
    return <TopView>
      <ModalBaseContainer visible={props.visible} contentStyle={{
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    }}>
        
        <LImage source={{
        uri: 'https://p0.meituan.net/ingee/dc6401c52fa421f5b94d5491a433d1008416.png'
    }} style={{
        width: '564rpx',
        height: '771rpx'
    }}>
          
          <View className="publicity-popup-header">
            <View className="publicity-popup-title-container">
              <Image source={{
        uri: 'https://p0.meituan.net/ingee/3af751781ba1013caf569663bb2226321168.png'
    }} style={{
        width: '33.7rpx',
        height: '36rpx'
    }}/>
              <Text className="publicity-popup-title" numberOfLines={1}>{teamName || '榜单公示'}</Text>
              <LImage source={{
        uri: 'https://p0.meituan.net/ingee/ececddce68903eb1a1df5db2b1cb0e791229.png'
    }} style={{
        width: '33.7rpx',
        height: '36rpx'
    }}/>
            </View>

            
            <View className="publicity-popup-call-section">
              <LImage source={{
        uri: 'https://p0.meituan.net/ingee/0e5afcae95732fdb08dce3fc867e0892739.png'
    }} style={{
        width: '21rpx',
        height: '28rpx',
        marginRight: '6rpx'
    }}/>
              <Text className="publicity-popup-call-label">{props.callValueDesc || '心愿值'}：{teamValue || 0}</Text>
            </View>
          </View>

          
          <View className="publicity-popup-content">
            <View className="publicity-popup-rank-section">
              <Text x-if={teamRank} className="publicity-popup-rank-text">第{teamRank}名</Text>
              <Text className="publicity-popup-rank-highlight">
                {props.teamInfo ? <Text className="publicity-popup-rank-highlight-text" style={{
        color: '#111111'
    }}>
                      {obtainReward ? '小队已获得奖励！' : '免单只差一点点～'}
                    </Text> : <Text className="publicity-popup-rank-highlight-text" style={{
        color: '#111111'
    }}>
                      您上期没有加入队伍
                    </Text>}
              </Text>
            </View>
          </View>

          
          <View className="publicity-popup-winners">
            <Text className="publicity-popup-winners-title">上期获奖队伍</Text>
            <View className="publicity-popup-winners-list">
              <RecyclerView onEndReached={loadMore} onEndReachedThreshold={100} showsVerticalScrollIndicator={false}>
                {winnerTeams.map((team, index) => <RecyclerView.Cell>
                    <View key={index} className="publicity-popup-winner-item">
                      <Text className="publicity-popup-winner-rank">{team.teamRank}</Text>
                      <Avatar avatar={team.teamImg}/>
                      <View className="publicity-popup-winner-info">
                        <Text className="publicity-popup-winner-name" numberOfLines={1}>{team.teamName}</Text>
                        <View className="publicity-popup-winner-call">
                          <LImage source={{
        uri: 'https://p0.meituan.net/ingee/0e5afcae95732fdb08dce3fc867e0892739.png'
    }} style={{
        width: '21rpx',
        height: '28rpx',
        marginRight: '4rpx'
    }}/>
                          <Text className="publicity-popup-winner-call-text">{props.callValueDesc || '心愿值'}：{team.teamValue}</Text>
                        </View>
                      </View>
                      <Text className="publicity-popup-winner-status">{team.obtainRewardType === RewardType.FREE_CARD ? '已得免单' : team.obtainRewardType === RewardType.POINTS ? '已得积分' : '未上榜'}</Text>
                    </View>
                  </RecyclerView.Cell>)}
              </RecyclerView>
            </View>
          </View>

          
          <View style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '10rpx'
    }}>
            <ModalBottomBtn buttonText={'我知道了'} onPress={props.onClose}/>
          </View>
        </LImage>

        
        <LImage onPress={props.onClose} source={{
        uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
    }} style={{
        width: '48rpx',
        height: '48rpx',
        marginTop: '52rpx'
    }}/>
      </ModalBaseContainer>
    </TopView>;
}
